import { RepaymentBulkIntrumentReduxStateWithoutListObject, RepaymentBulkIntrumentReduxStateWithListObject, RepaymentInstrumentBulkRequestReducerDispatch, RepaymentInstrumentBulkRequestType } from "./types";

const OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE = {
  data: {},
  loading: false,
  error: null
};

const OBJECT_WITH_LIST_RESPONSE_INIT_STATE = {
  data: {
    metadata: {
      totalCount: 0,
      currentPageRecords: 0,
      totalPages: 0,
      links: {
        self: null,
        first: null,
        previous: null,
        next: null,
        last: null
      }
    },
    records: []
  },
  loading: false,
  error: null
};

const CreateRepaymentBulkIntrumentReducer = (state: RepaymentBulkIntrumentReduxStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: RepaymentInstrumentBulkRequestReducerDispatch) => {
  switch (action.type) {
    case RepaymentInstrumentBulkRequestType.CREATE_REPAYMENT_INSTRUMENT_BULK_REQUEST: {
      return {
        ...state,
        loading: true
      };
    }
    case RepaymentInstrumentBulkRequestType.CREATE_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case RepaymentInstrumentBulkRequestType.CREATE_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
    case RepaymentInstrumentBulkRequestType.RESET_CREATE_REPAYMENT_INSTRUMENT_BULK_REQUEST: {
      return {
        data: {},
        loading: false,
        error: null
      };
    }
    default:
      return { ...state };
  }
};

const RepaymentBulkIntrumentsListReducer = (state: RepaymentBulkIntrumentReduxStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE, action: RepaymentInstrumentBulkRequestReducerDispatch) => {
  switch (action.type) {
    case RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST: {
      return {
        ...state,
        data: action.payload.data,
        loading: true
      };
    }
    case RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
    case RepaymentInstrumentBulkRequestType.RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST:
      return {
        ...state,
        data: {
          metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
              self: null,
              first: null,
              previous: null,
              next: null,
              last: null
            }
          },
          records: []
        },
        loading: false,
        error: null
      };
    default:
      return { ...state };
  }
};

const RepaymentBulkIntrumentsFiltersListReducer = (state: RepaymentBulkIntrumentReduxStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE, action: RepaymentInstrumentBulkRequestReducerDispatch) => {
  switch (action.type) {
    case RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_FILTERS: {
      return {
        ...state,
        loading: true
      };
    }
    case RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_FILTERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.data
      };
    }
    case RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_FILTERS_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };
    }
    case RepaymentInstrumentBulkRequestType.RESET:
      return {
        ...state,
        data: {
          metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
              self: null,
              first: null,
              previous: null,
              next: null,
              last: null
            }
          },
          records: []
        },
        loading: false,
        error: null
      };
    default:
      return { ...state };
  }
};

const RepaymentBulkIntrumentDetailReducer = (state: RepaymentBulkIntrumentReduxStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: RepaymentInstrumentBulkRequestReducerDispatch) => {
  switch (action.type) {
    case RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_DETAIL: {
      return {
        ...state,
        loading: true
      };
    }
    case RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_DETAIL_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_DETAIL_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
    case RepaymentInstrumentBulkRequestType.RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_DETAIL:
      return {
        ...state,
        data: {},
        loading: false,
        error: null
      };
    default:
      return { ...state };
  }
};

const RepaymentBulkIntrumentVersionReducer = (state: RepaymentBulkIntrumentReduxStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE, action: RepaymentInstrumentBulkRequestReducerDispatch) => {
  switch (action.type) {
    case RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_VERSION: {
      return {
        ...state,
        loading: true
      };
    }
    case RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_VERSION_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.data
      };
    }
    case RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_VERSION_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };
    }
    case RepaymentInstrumentBulkRequestType.RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_VERSION:
      return {
        ...state,
        data: {
          metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
              self: null,
              first: null,
              previous: null,
              next: null,
              last: null
            }
          },
          records: []
        },
        loading: false,
        error: null
      };
    default:
      return { ...state };
  }
};

const ApproveRepaymentBulkIntrumentReducer = (state: RepaymentBulkIntrumentReduxStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: RepaymentInstrumentBulkRequestReducerDispatch) => {
  switch (action.type) {
    case RepaymentInstrumentBulkRequestType.APPROVE_REPAYMENT_INSTRUMENT_BULK_REQUEST: {
      return {
        ...state,
        loading: true
      };
    }
    case RepaymentInstrumentBulkRequestType.APPROVE_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.data
      };
    }
    case RepaymentInstrumentBulkRequestType.APPROVE_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };
    }
    case RepaymentInstrumentBulkRequestType.RESET_APPROVE_REPAYMENT_INSTRUMENT_BULK_REQUEST:
      return {
        ...state,
        data: {},
        loading: false,
        error: null
      };
    default:
      return { ...state };
  }
};

const RejectRepaymentBulkIntrumentReducer = (state: RepaymentBulkIntrumentReduxStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: RepaymentInstrumentBulkRequestReducerDispatch) => {
  switch (action.type) {
    case RepaymentInstrumentBulkRequestType.REJECT_REPAYMENT_INSTRUMENT_BULK_REQUEST: {
      return {
        ...state,
        loading: true
      };
    }
    case RepaymentInstrumentBulkRequestType.REJECT_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.data
      };
    }
    case RepaymentInstrumentBulkRequestType.REJECT_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };
    }
    case RepaymentInstrumentBulkRequestType.RESET_REJECT_REPAYMENT_INSTRUMENT_BULK_REQUEST:
      return {
        ...state,
        data: {},
        loading: false,
        error: null
      };
    default:
      return { ...state };
  }
};

const RepaymentBulkIntrumentSettledEntriesReducer = (state: RepaymentBulkIntrumentReduxStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE, action: RepaymentInstrumentBulkRequestReducerDispatch) => {
  switch (action.type) {
    case RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES: {
      return {
        ...state,
        loading: true
      };
    }
    case RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.data
      };
    }
    case RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };
    }
    case RepaymentInstrumentBulkRequestType.RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES:
      return {
        ...state,
        data: {
          metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
              self: null,
              first: null,
              previous: null,
              next: null,
              last: null
            }
          },
          records: []
        },
        loading: false,
        error: null
      };
    default:
      return { ...state };
  }
};


const RepaymentBulkIntrumentSettledEntriesDetailReducer = (state: RepaymentBulkIntrumentReduxStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: RepaymentInstrumentBulkRequestReducerDispatch) => {
  switch (action.type) {
    case RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_DETAIL: {
      return {
        ...state,
        loading: true
      };
    }
    case RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_DETAIL_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_DETAIL_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
    case RepaymentInstrumentBulkRequestType.RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_DETAIL
      :
      return {
        ...state,
        data: {},
        loading: false,
        error: null
      };

    default:
      return { ...state };
  }
};

const ReviewRepaymentBulkIntrumentReducer = (state: RepaymentBulkIntrumentReduxStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: RepaymentInstrumentBulkRequestReducerDispatch) => {
  switch (action.type) {
    case RepaymentInstrumentBulkRequestType.REVIEW_REPAYMENT_INSTRUMENT_BULK_REQUEST: {
      return {
        ...state,
        loading: true
      };
    }
    case RepaymentInstrumentBulkRequestType.REVIEW_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case RepaymentInstrumentBulkRequestType.REVIEW_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
    case RepaymentInstrumentBulkRequestType.RESET_REVIEW_REPAYMENT_INSTRUMENT_BULK_REQUEST
      :
      return {
        ...state,
        data: {},
        loading: false,
        error: null
      };

    default:
      return { ...state };
  }
};


const RepaymentBulkIntrumentAuditReducer = (state: RepaymentBulkIntrumentReduxStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE, action: RepaymentInstrumentBulkRequestReducerDispatch) => {
  switch (action.type) {
    case RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_AUDIT: {
      return {
        ...state,
        loading: true
      };
    }
    case RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_AUDIT_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_AUDIT_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
    case RepaymentInstrumentBulkRequestType.RESET_FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_AUDIT:
      return {
        ...state,
        data: {
          metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
              self: null,
              first: null,
              previous: null,
              next: null,
              last: null
            }
          },
          records: []
        },
        loading: false,
        error: null
      };
    default:
      return { ...state };
  }
};

export {
  CreateRepaymentBulkIntrumentReducer,
  RepaymentBulkIntrumentsListReducer,
  RepaymentBulkIntrumentsFiltersListReducer,
  RepaymentBulkIntrumentDetailReducer,
  RepaymentBulkIntrumentVersionReducer,
  ApproveRepaymentBulkIntrumentReducer,
  RejectRepaymentBulkIntrumentReducer,
  RepaymentBulkIntrumentSettledEntriesReducer,
  RepaymentBulkIntrumentSettledEntriesDetailReducer,
  ReviewRepaymentBulkIntrumentReducer,
  RepaymentBulkIntrumentAuditReducer
}